import wheelDirection from './component/wheelDirection';
import isPreventTime from './component/isPreventTime';

import Intro from './page/intro';
import BossOne from './page/bossOne';
import BossTwo from './page/bossTwo';
import BossThree from './page/bossThree';
import HeroOne from './page/heroOne';
import StoryOne from './page/storyOne';
import StoryTwo from './page/storyTwo';
import DungeonOne from './page/dungeonOne';
import GunnerOne from './page/gunnerOne';
import SystemOne from './page/systemOne';
import SystemTwo from './page/systemTwo';

const intro = new Intro();
const bossOne = new BossOne();
const bossTwo = new BossTwo();
const bossThree = new BossThree();
const heroOne = new HeroOne();
const storyOne = new StoryOne();
const storyTwo = new StoryTwo();
const dungeonOne = new DungeonOne();
const gunnerOne = new GunnerOne();
const systemOne = new SystemOne();
const systemTwo = new SystemTwo();

const page = {intro, bossOne, bossTwo, bossThree, heroOne, storyOne, storyTwo, dungeonOne, gunnerOne, systemOne, systemTwo};

let context = $('.section-page');
let nowCount = 0;
let maxCount = 10;
let target = {};
let init = {};
let timer;
let slideArea = $('.slide-area');
let initLayer = $('.movie-init');
let currentPage = ['intro', 'intro1'];
let DOM_MovieLayer = $('.layer-movie');
let DOM_MovieLayer_full = $('.full-layer-movie');
let DOM_MovieLayer_full2 = $('.full-layer-movie2');
let DOM_MovieLayer_full3 = $('.full-layer-movie3');

let setPage = (direction) =>{
    if(nowCount + direction < 0 || nowCount + direction > maxCount) return;
    nowCount = nowCount + direction;
    
    render(nowCount);
};

let render = (renderId) =>{
    let go, id;
    [go, id] = pageMap(renderId);
    
    let query = go + id;
    
    if(currentPage) {
        page[currentPage[0]].reset(currentPage[1]);
    }
    
    setNaviActive(query);
    
    page[go].start(query);
    $('.menu').removeClass('open');
    currentPage = [go, query];
};

let setNaviActive = (query) =>{
    $('.nav-list a').removeClass('active');
    
    switch(query){
        case 'bossOne1':
        case 'bossTwo1':
        case 'bossThree1':
            $('.nav-01 > a').addClass('active');
            break;
        case 'heroOne1':
            $('.nav-02 > a').addClass('active');
            break;
        case 'storyOne1':
        case 'storyTwo1':
            $('.nav-03 > a').addClass('active');
            break;
        case 'dungeonOne1':
            $('.nav-04 > a').addClass('active');
            break;
        case 'gunnerOne1':
            $('.nav-05 > a').addClass('active');
            break;
        case 'systemOne1':
        case 'systemTwo1':
            $('.nav-06 > a').addClass('active');
            break;
    }
};

let pageMap = (value) =>{
    let map = {
        0: ['intro', 1],
        1: ['bossOne', 1],
        2: ['bossTwo', 1],
        3: ['bossThree', 1],
        4: ['heroOne', 1],
        5: ['storyOne', 1],
        6: ['storyTwo', 1],
        7: ['dungeonOne', 1],
        8: ['gunnerOne', 1],
        9: ['systemOne', 1],
        10: ['systemTwo', 1]
    };
    
    return map[value];
};

let naviMap = (value) =>{
    let map = {
        '#page-intro': 0,
        '#page-boss1': 1,
        '#page-boss2': 2,
        '#page-boss3': 3,
        '#page-hero1': 4,
        '#page-story1': 5,
        '#page-story2': 6,
        '#page-dungeon1': 7,
        '#page-gunner1': 8,
        '#page-system1': 9,
        '#page-system2': 10
    };
    return map[value];
};

let config = {
    isSoundPlay: false,
    isPlayerSoundStop: false
};

$(document).on('click', '.btn-link-bgm', function(e){
    e.originalEvent && (config.isPlayerSoundStop = !config.isPlayerSoundStop);
    
    e.preventDefault();
    let $self;
    
    $self = $(this);
    
    if(config.isSoundPlay && $self.hasClass('play')) {
        config.isSoundPlay = false;
        soundManager.pause('sound');
        $self.removeClass('play').addClass('pause');
    } else {
        config.isSoundPlay = true;
        soundManager.play('sound');
        $self.removeClass('pause').addClass('play');
    }
});

$(document).on('click', '.btn-link-index', function(e){
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

$(document).on('click', '.cmplay .btn-close', function(e){
    e.preventDefault();
    $('.cmplay').hide();
});

$(document).on('click', '.nav-list a', function(e){
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

init.videoBg = new nc.ui.Player({
    selector: '#bg-video-init',
    videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_intro.mp4',
    mute: false,
    autoPlay: false,
    loop: false
});
nc.ui.Player.movieLayer = new nc.ui.Player({
    selector: '#movie-box',
    videoId: 'RjANlnUxVBk',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull = new nc.ui.Player({
    selector: '#movie-box-full',
    videoId: 'ZpFj1UxF0x4',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull2 = new nc.ui.Player({
    selector: '#movie-box-full2',
    videoId: 'http://vodfile.ncsoft.co.kr/ncvod/plaync/BNS/fd/fd_story.mp4',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

nc.ui.Player.movieLayerFull3 = new nc.ui.Player({
    selector: '#movie-box-full3',
    videoId: '6KeMAEKWyhc',
    mute: false,
    autoPlay: false,
    loop: false,
    controls: true
});

$(document).on('click', '.menu-trigger', function(e){
    e.preventDefault();
    $('.menu').addClass('open');
});
$(document).on('click', '.menu-close', function(e){
    e.preventDefault();
    $('.menu').removeClass('open');
});

$(document).on('click', '.btn-open-event', function(e){
    e.preventDefault();
    $(this).closest('.event-wrap').toggleClass('open');
});

$(document).on('click', '.btn-link-movie', function(e){
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full.fadeIn();
    nc.ui.Player.movieLayerFull.play();
    $(window).trigger('resize');
});


$(document).on('click', '.btn-link-cmplay', function(e){
    e.preventDefault();
    
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    
    DOM_MovieLayer.fadeIn();
    
    nc.ui.Player.movieLayer.play();
    
    $(window).trigger('resize');
});
$(document).on('click', '.btn-view-content-movie', function(e){
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full3.fadeIn();
    nc.ui.Player.movieLayerFull3.play();
    $(window).trigger('resize');
});
$(document).on('click', '.btn-play-flamemovie', function(e){
    e.preventDefault();
    config.isSoundPlay && $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer_full2.fadeIn();
    nc.ui.Player.movieLayerFull2.play();
    $(window).trigger('resize');
});
$(document).on('click', '.btn-view-cm', function(e){
    e.preventDefault();
    $('.btn-link-bgm').trigger('click');
    DOM_MovieLayer.fadeIn();
    nc.ui.Player.movieLayer.play();
    $(window).trigger('resize');
});

$(document).on('click', '.layer-movie .btn-close', function(e){
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayer.stop();
    DOM_MovieLayer.hide();
});

$(document).on('click', '.full-layer-movie .btn-close', function(e){
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull.stop();
    DOM_MovieLayer_full.hide();
});

$(document).on('click', '.full-layer-movie2 .btn-close', function(e){
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull2.stop();
    DOM_MovieLayer_full2.hide();
});

$(document).on('click', '.full-layer-movie3 .btn-close', function(e){
    e.preventDefault();
    !config.isPlayerSoundStop && $('.btn-link-bgm').trigger('click');
    nc.ui.Player.movieLayerFull2.stop();
    DOM_MovieLayer_full3.hide();
});

$(document).on('click', '.btn-link-skip', function(e){
    e.preventDefault();
    
    init.videoBg.pause();
    initLayer.fadeOut();
    
    $('.container').css({
        'visibility': 'visible'
    });
    page['intro'].start('intro1');
    
    clearTimeout(timer);
    
    $('.header').addClass('animate');
    $('.btn-link-bgm').trigger('click');
});

context.on('mousewheel DOMMouseScroll', (e) =>{
    e.stopPropagation();
    if(isPreventTime(window.lastWheelTime)) return;
    window.lastWheelTime = new Date().getTime();
    
    setPage(wheelDirection(e));
});
$('.nav-list li').hover(function(){
    $(this).addClass('hover');
}, function(){
    $(this).removeClass('hover');
});

new nc.promo.preloader({
    'drawSize': 5,
    'resourcePath': '/promo/bns/history/2017/171206_flamedragon',
    'preLoadList': [
        '/img/system/bg-obj6-2-2-img.png',
        '/img/system/bg-obj6-2-movie.jpg',
        '/img/system/bg-system1.jpg',
        '/img/system/bg-system2-1-blur.jpg',
        '/img/system/bg-system2-1-full.jpg',
        '/img/system/bg-system2-1.jpg',
        '/img/system/bg-system2-2-blur.jpg',
        '/img/system/bg-system2-2-full.jpg',
        '/img/system/bg-system2-2.jpg',
        '/img/system/bg-system2.jpg',
        '/img/system/obj6-1-banner1.png',
        '/img/system/obj6-1-chr1.png',
        '/img/system/obj6-1-chr2.png',
        '/img/system/obj6-1-chr3.png',
        '/img/system/obj6-1-chr4.png',
        '/img/system/obj6-1-tit.png',
        '/img/system/obj6-1-txt1.png',
        '/img/system/obj6-2-1-txt1.png',
        '/img/system/obj6-2-tit.png',
        '/img/system/txt-system2-1.png',
        '/img/system/txt-system2-2.png',
        '/img/story/bg-movie-3-1.jpg',
        '/img/story/bg-slide-area.png',
        '/img/story/bg-story.jpg',
        '/img/story/circle-slider.png',
        '/img/story/frame-movie-layer.png',
        '/img/story/img-area-1-1.jpg',
        '/img/story/img-area-1-2.jpg',
        '/img/story/img-area-1-3.jpg',
        '/img/story/img-area-1-4.jpg',
        '/img/story/img-area-2-1.jpg',
        '/img/story/img-area-2-2.jpg',
        '/img/story/img-area-2-3.jpg',
        '/img/story/img-area-2-4.jpg',
        '/img/story/img-area-3-1.jpg',
        '/img/story/img-area-3-2.jpg',
        '/img/story/img-area-3-3.jpg',
        '/img/story/img-area-3-4.jpg',
        '/img/story/obj3-1-chr1.png',
        '/img/story/obj3-1-chr2.png',
        '/img/story/obj3-1-chr3.png',
        '/img/story/obj3-1-chr4.png',
        '/img/story/obj3-1-sd.png',
        '/img/story/obj3-1-tit.png',
        '/img/story/obj3-1-txt1.png',
        '/img/story/obj3-2-tit.png',
        '/img/story/obj3-2-txt1.png',
        '/img/story/pager.png',
        '/img/intro/bg-arrow.png',
        '/img/intro/bg-intro.jpg',
        '/img/intro/btn-cmmovie.png',
        '/img/intro/btn-reservation.png',
        '/img/intro/btn-update.png',
        '/img/intro/obj0-chr1.png',
        '/img/intro/obj0-chr2.png',
        '/img/intro/obj0-chr3.png',
        '/img/intro/obj0-chr4.png',
        '/img/intro/obj0-chr5.png',
        '/img/intro/obj0-chr6.png',
        '/img/intro/obj0-chr7.png',
        '/img/intro/quick-links.png',
        '/img/intro/tit_intro_1.png',
        '/img/intro/txt-copyright.png',
        '/img/intro/txt-scroll.png',
        '/img/hero/bg-hero.jpg',
        '/img/hero/bg-movie-2-1.jpg',
        '/img/hero/frame-movie-layer.png',
        '/img/hero/obj2-1-chr1.png',
        '/img/hero/obj2-1-tit.png',
        '/img/hero/obj2-1-txt1.png',
        '/img/hero/obj2-1-txt2.png',
        '/img/gunner/bg-gunner.jpg',
        '/img/gunner/obj5-1-chr1-tip.png',
        '/img/gunner/obj5-1-chr1.png',
        '/img/gunner/obj5-1-chr2.png',
        '/img/gunner/obj5-1-tit.png',
        '/img/gunner/obj5-1-txt1.png',
        '/img/dungeon/bg-dungeon1-blur.jpg',
        '/img/dungeon/bg-dungeon1-full.jpg',
        '/img/dungeon/bg-dungeon1.jpg',
        '/img/dungeon/bg-dungeon2-blur.jpg',
        '/img/dungeon/bg-dungeon2-full.jpg',
        '/img/dungeon/bg-dungeon2.jpg',
        '/img/dungeon/bg-dungeon3-blur.jpg',
        '/img/dungeon/bg-dungeon3-full.jpg',
        '/img/dungeon/bg-dungeon3.jpg',
        '/img/dungeon/bg_dungeon_close.png',
        '/img/dungeon/obj4-1-chr1-eff.png',
        '/img/dungeon/obj4-1-chr1-tip.png',
        '/img/dungeon/obj4-1-chr1.png',
        '/img/dungeon/obj4-1-chr2-eff.png',
        '/img/dungeon/obj4-1-chr2-tip.png',
        '/img/dungeon/obj4-1-chr2.png',
        '/img/dungeon/obj4-1-tit.png',
        '/img/dungeon/obj4-1-txt1.png',
        '/img/dungeon/obj4-2-chr1-eff.png',
        '/img/dungeon/obj4-2-chr1-tip.png',
        '/img/dungeon/obj4-2-chr1.png',
        '/img/dungeon/obj4-2-tit.png',
        '/img/dungeon/obj4-2-txt1.png',
        '/img/dungeon/obj4-3-chr1-eff.png',
        '/img/dungeon/obj4-3-chr1-tip.png',
        '/img/dungeon/obj4-3-chr1.png',
        '/img/dungeon/obj4-3-tit.png',
        '/img/dungeon/obj4-3-txt1.png',
        '/img/dungeon/shadow-detail.png',
        '/img/dungeon/tit-dungeon1-1.png',
        '/img/dungeon/tit-dungeon1-2.png',
        '/img/dungeon/tit-dungeon1-3.png',
        '/img/dungeon/txt-dungeon1-1.png',
        '/img/dungeon/txt-dungeon1-2.png',
        '/img/dungeon/txt-dungeon1-3.png',
        '/img/common/arw_slide_next.png',
        '/img/common/arw_slide_prev.png',
        '/img/common/bg-back.jpg',
        '/img/common/bg-logo.jpg',
        '/img/common/bg-menu-close.png',
        '/img/common/bg-shadow.png',
        '/img/common/bg-shadow2.png',
        '/img/common/bg-shadow3.png',
        '/img/common/bg-util.png',
        '/img/common/bg-video.png',
        '/img/common/btn-dots-on.jpg',
        '/img/common/btn-open-event.png',
        '/img/common/btn-skip.png',
        '/img/common/btn_close.png',
        '/img/common/event-list.jpg',
        '/img/common/event-movie.jpg',
        '/img/common/logo-top.png',
        '/img/common/navi.png',
        '/img/common/pause.png',
        '/img/common/play.png',
        '/img/common/sns-share.png',
        '/img/boss/bg-boss.jpg',
        '/img/boss/bg-boss1.jpg',
        '/img/boss/obj1-1-chr1-eff.png',
        '/img/boss/obj1-1-chr1-sd.png',
        '/img/boss/obj1-1-chr1.png',
        '/img/boss/obj1-1-chr2.png',
        '/img/boss/obj1-1-tit.png',
        '/img/boss/obj1-1-txt1.png',
        '/img/boss/obj1-2-chr1-eff.png',
        '/img/boss/obj1-2-chr1-sd.png',
        '/img/boss/obj1-2-chr1.png',
        '/img/boss/obj1-2-chr2.png',
        '/img/boss/obj1-2-tit.png',
        '/img/boss/obj1-2-txt1.png',
        '/img/boss/obj1-3-chr1-eff.png',
        '/img/boss/obj1-3-chr1-sd.png',
        '/img/boss/obj1-3-chr1.png',
        '/img/boss/obj1-3-chr2.png',
        '/img/boss/obj1-3-tit1.png',
        '/img/boss/obj1-3-tit2.png',
        '/img/boss/obj1-3-txt1.png',
        '/img/boss/obj1-3-txt2.png'
    ],
    'game': 'bns'
});

$(document).on('preLoaded', function(){
    $('.container').css({
        'visibility': 'visible'
    });
    
    $('.container').addClass('screen-ready');
    
    if(/#(page-boss1|page-hero1|page-story1|page-dungeon1|page-gunner1|page-system1)/.test(window.location.hash)) {
        initLayer.hide();
        nowCount = naviMap(window.location.hash);
        render(nowCount);
        
        $('.header').addClass('animate');
        $('.btn-link-bgm').trigger('click');
    } else {
        init.videoBg.play();
        
        timer = setTimeout(() =>{
            initLayer.fadeOut();
            init.videoBg.pause();
            page['intro'].start('intro1');
            $('.header').addClass('animate');
            $('.btn-link-bgm').trigger('click');
        }, 9000);
    }
});


// WEBPACK FOOTER //
// ./history/2017/171206_flamedragon/_src/js/App.js